<template>
  <v-autocomplete
    multiple
    :label="label"
    :items="items"
    :disabled="disabled"
    v-model="selected"
    item-disabled="disabled"
    :item-text="itemText"
    :item-value="returnObject ? undefined : itemValue"
    :return-object="returnObject"
  >
    <template v-slot:prepend-item>
      <v-list-tile
        ripple
        @click="toggle"
      >
        <v-list-tile-action>
          <v-icon :color="selected.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t('selectAll') }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider class="mt-2"></v-divider>
    </template>
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index <= displayQty"> 
        <span>{{ item[chipText] }}</span>
      </v-chip>
      <span
        v-if="index === (displayQty + 1)"
        class="grey--text caption"
      >(+{{ selected.length - 2 }} {{ selected.length - 2 > 1 ? $t('othersLower') : $t('otherLower') }})</span>
    </template>
  </v-autocomplete>
</template>

<script>
import {deepEqual} from '@/utils/tools'

export default {
  name: 'SelectWidget', // support select all
  data () {
    return {
      selected: []
    }
  },
  watch: {
    selected (value) {
      if (deepEqual(value, this.value)) return
      if (this.mutuallyExclusives && this.mutuallyExclusives.length > 0) {
        this.items.forEach((i, index) => {
          value.forEach((item) => {
            const idx = this.items.findIndex(i => i[this.itemValue] === item)
            if (this.mutuallyExclusives.includes(this.returnObject ? item[this.itemValue] : item)) {
              if (idx !== index && this.mutuallyExclusives.includes(i[this.itemValue])) {
                this.$set(this.items[index], 'disabled', true)
              } else {
                this.$delete(this.items[index], 'disabled')
              }
            }
          })
        })
        !value.some(item => this.mutuallyExclusives.includes(this.returnObject ? item[this.itemValue] : item)) && this.resetItems()
      }
      this.$emit('input', value)
    },
    value (value) {
      this.selected = [...value]
    }
  },
  computed: {
    selectedAll () {
      return this.selected.length === this.items?.length
    },
    selectedSome () {
      return this.selected.length > 0 && !this.selectedAll
    },
    icon () {
      if (this.selectedAll) return 'check_box'
      if (this.selectedSome) return 'indeterminate_check_box'
      return 'check_box_outline_blank'
    }
  },
  methods: {
    resetItems () {
      if (this.mutuallyExclusives && this.mutuallyExclusives.length > 0) {
        this.items.forEach((i, index) => {
          if (this.mutuallyExclusives.includes(i[this.itemValue])) {
            this.$delete(this.items[index], 'disabled')
          }
        })
      }
    },
    toggle () {
      const filterCb = item => {
        if (this.mutuallyExclusives.length && this.mutuallyExclusives.includes(item[this.itemValue])) {
          return this.mutuallyExclusives.indexOf(item[this.itemValue]) === 0
        } 
        return true
      }
      this.$nextTick(() => {
        if (this.selectedAll || this.selected.length === this.items.filter(item => !item.disabled).length) {
          this.resetItems()
          this.selected = []
        } else {
          this.resetItems()
          this.selected = this.returnObject ? [...this.items].filter(filterCb) : this.items.filter(filterCb).map(item => item[this.itemValue])
        }
      })
    }
  },
  props: {
    value: Array,
    items: Array,
    label: String,
    itemText: String,
    chipText: String,
    itemValue: String,
    displayQty: {
      type: Number,
      default: 1
    },
    returnObject: Boolean,
    mutuallyExclusives: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SelectWidget.vue